import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Get all form elements that could trigger a change event
    const formElements = this.element.querySelectorAll("input, select, textarea")

    // Add change event listener to each form element
    formElements.forEach(element => {
      element.addEventListener("change", this.submitForm.bind(this))
    })
  }

  submitForm() {
    // Submit the form
    this.element.requestSubmit()
  }
}
